import React from 'react'

import { ChatButton } from "/react4xp/shared/chat-button/chat-button";

export default (props) => <ChatButton {...props} />
